import React from "react";
import { guideKeywords } from "../mock";
import { useI18n } from "../lib/i18n";
import { useSettings } from "../lib/settings";
import { T } from "../lib/autoTranslate";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "./ui/carousel";

const Testimonials = () => {
  const { t } = useI18n();
  const { settings } = useSettings();
  const s = settings || {};
  const items = s.testimonials || [];
  const doubled = [...guideKeywords, ...guideKeywords];

  return (
    <section id="reviews" className="section bg-[var(--ri-cream)]">
      <div className="container-x">
        <div className="divider mb-14" />
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <p className="eyebrow mb-3"><T>{s.testimonials_eyebrow || t("reviews_eyebrow")}</T></p>
            <h2 className="font-serif-display text-[30px] md:text-[36px] leading-[1.1] max-w-[720px]">
              <T>{s.testimonials_title || t("reviews_title")}</T>
            </h2>
            {s.testimonials_intro && (
              <p className="mt-4 max-w-[640px] text-[15px] leading-[1.7] text-[var(--ri-ink-soft)]">
                {s.testimonials_intro}
              </p>
            )}
          </div>
        </div>

        <div className="mt-8 relative overflow-hidden">
          <div className="marquee-track w-max">
            {doubled.map((k, i) => (
              <span key={i} className="whitespace-nowrap px-4 py-2 rounded-full border border-[var(--ri-border)] bg-[#fffdf7] text-[13px] text-[var(--ri-ink-soft)] mr-2">
                <T>{k}</T>
              </span>
            ))}
          </div>
        </div>

        {items.length > 0 && (
          <div className="mt-10">
            <Carousel opts={{ align: "start", loop: true }} className="w-full">
              <CarouselContent>
                {items.map((tt, i) => (
                  <CarouselItem key={i} className="sm:basis-1/2 lg:basis-1/3">
                    <div className="h-full rounded-2xl border border-[var(--ri-border)] bg-[#fffdf7] p-5 flex flex-col">
                      <h4 className="font-serif-display text-[17px] leading-[1.25]">{tt.title}</h4>
                      <p className="mt-2.5 text-[13.5px] leading-[1.55] text-[var(--ri-ink-soft)] line-clamp-4">
                        {tt.quote}
                      </p>
                      <div className="mt-4 text-[12.5px] pt-3 border-t border-[var(--ri-border)]">
                        <span className="font-semibold">{tt.author}</span>
                        <span className="text-[var(--ri-muted)]"> {tt.source}</span>
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <div className="flex items-center justify-end gap-2 mt-5">
                <CarouselPrevious className="static translate-y-0 h-9 w-9" />
                <CarouselNext className="static translate-y-0 h-9 w-9" />
              </div>
            </Carousel>
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
